export default class ImageService {
  constructor(firebase) {
    this.firebase = firebase;
  }

  async getImageBlobFromBase64Url(base64Url) {
    const res = await fetch(base64Url);
    const blob = await res.blob();

    return blob;
  }

  async getImageFromUrl(imageUrl) {
    return new Promise(async(resolve, reject) => {
      try {
        const response = { isHorizontal: false };
        const { data: base64Image } = await this.firebase.functions().httpsCallable('httpImageUrlBase64')({ image: encodeURIComponent(imageUrl) });
        const base64Url = `data:image/png;base64,${base64Image}`;

        const imageDimensions = await this.getImageDimensions(base64Url);

        if (imageDimensions.width > imageDimensions.height) {
          const rotatedCanvas = document.createElement('canvas');
          const rotatedContext = rotatedCanvas.getContext('2d');

          const rotatedImage = new Image();

          rotatedImage.onload = async() => {
            rotatedCanvas.height = rotatedImage.width;
            rotatedCanvas.width = rotatedImage.height;

            rotatedContext.rotate(-90 * Math.PI / 180);
            rotatedContext.translate(-rotatedCanvas.height, 0);

            rotatedContext.drawImage(rotatedImage, 0, 0);

            response.base64Url = rotatedCanvas.toDataURL('image/png');
            response.blob = await this.getImageBlobFromBase64Url(response.base64Url);
            response.isHorizontal = true;
            resolve(response);
          };

          rotatedImage.src = base64Url;
        } else {
          response.base64Url = base64Url;
          response.blob = await this.getImageBlobFromBase64Url(response.base64Url);
          resolve(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  async getImageDimensions(imageUrl) {
    try {
      const img = new Image();
      img.src = imageUrl;

      await img.decode();

      return { width: img.width, height: img.height };
    } catch (e) {
      return {};
    }
  }
}
